var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitchProfile = function SvgSwitchProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    d: "M18.715 1.716a1.01 1.01 0 0 1 0-1.422 1 1 0 0 1 1.417 0l2.272 2.28.013.013a2.014 2.014 0 0 1-.005 2.836l-2.275 2.283a1 1 0 0 1-1.416 0 1.007 1.007 0 0 1 0-1.421L20.001 5H5a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0V6a3 3 0 0 1 3-3h14.995zM22 11a1 1 0 1 0-2 0v7a1 1 0 0 1-1 1H4.003l1.28-1.284a1.01 1.01 0 0 0 0-1.422 1 1 0 0 0-1.418 0l-2.271 2.28-.013.013a2.014 2.014 0 0 0 .005 2.836l2.274 2.283a1 1 0 0 0 1.416 0 1.007 1.007 0 0 0 0-1.421L3.996 21H19a3 3 0 0 0 3-3z"
  })));
};
export default SvgSwitchProfile;